import { createContext, useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import api from "../../../api/resources";

export const ClientsContext = createContext(null);

export function ClientsProvider({ children }) {
  const { t } = useTranslation(["common", "reseller"]);

  const types = ["managed", "archived"];
  const tabs = types.map((type) => ({
    type,
    title: t(`reseller:clients.tabs.${type}`),
  }));
  const [selectedTab, setSelectedTab] = useState("managed");
  const handleSelectTab = (type) => setSelectedTab(type);

  const [allClients, setAllClients] = useState([]);
  const [loading, setLoading] = useState(true);

  const init = async () => {
    setLoading(true);
    const response = await api.getClients();
    if (response.ok) {
      const clients = await response.json();
      setAllClients(clients);
      setLoading(false);
    }
  };

  // enable client list update without refetching clients from api (useful for simple actions like archiving)
  const handleUpdateClients = (clientID, key, value) => {
    setAllClients((prevClients) =>
      prevClients.map((client) =>
        client.id === clientID
          ? {
              ...client,
              [key]: value,
            }
          : client,
      ),
    );
  };

  useEffect(() => {
    init();
  }, []);

  const value = {
    allClients,
    onClientsUpdate: handleUpdateClients,
    selectedTab,
    onTabSelect: handleSelectTab,
    tabs,
    init,
    loading: loading,
  };

  return <ClientsContext value={value}>{children}</ClientsContext>;
}

export function useClients() {
  return useContext(ClientsContext);
}
